/**
  * Max Volume - Min Volume > 20 (this detects whether a student is saying anything)
  * clip < 0.02 (this detects whether the student is talking too loud for us to measure)
  * Max Volume > softThreshold (this detects whether the overall noise is loud enough)
  */
export default function isAcceptableVolume(volumeStats) {

    if(!volumeStats) return false
    if(!Object.keys(volumeStats).length) return false

    const { db, maxVolume, minVolume, maxClip, clip, softThreshold, loudThreshold } = volumeStats

    // The number 20 is from some student sample
    // The clip 0.02 is from some student sample 
    // Any questions about these numbers -- please ask Pete J
    if (maxVolume - minVolume > 20 && maxClip < 0.02 && maxVolume > softThreshold) {
        return true
    }
    return false
}